import type { Config } from "../type";

export const DEFAULT_OPTION: Config = {
  keyFormat: "string",
  resFormat: "map",
  isAll: false,
  omit: [],
};
